// extracted by mini-css-extract-plugin
export default {"root":"SectionGrid21_root__todpa","content":"SectionGrid21_content__wt05M","gridContainer":"SectionGrid21_gridContainer__YZ8vx"};